import { z } from 'zod';

export const BehaviorSettings = z.union([
  z
    .object({
      layout_paragraphs: z
        .object({
          parent_uuid: z.string().optional().nullable(),
          region: z.string().optional().nullable(),
          layout: z.string().optional().nullable(),
          config: z.any().nullable(),
        })
        .optional(),
    })
    .strip()
    .optional(),
  z.array(z.undefined()).optional(),
]);

export type BehaviorSettings = z.infer<typeof BehaviorSettings>;
